import LoadingPopUp from '~/components/LoadingPopUp'
import { HeaderWalletBalance } from '~/modules/retailMedia/components/HeaderWalletBalance/HeaderWalletBalance'
import { WalletBalanceOrigin } from '~/modules/retailMedia/components/WalletBalanceOrigin'
import { WalletDetailSections } from '~/modules/retailMedia/components/WalletDetailSections'
import { WalletTableTransaction } from '~/modules/retailMedia/components/WalletTableTransaction'
import HeaderWallet from '~/modules/retailMedia/components/WalltetHeader'
import { useShowWalletOrigins } from '~/modules/retailMedia/hooks/useShowWalletOrigins'
import { useWalletByPair } from '~/modules/retailMedia/hooks/useWalletByPair'

const AdvertiserTransactions = () => {
  const showWalletOrigins = useShowWalletOrigins()
  const {
    wallet,
    hasMappedOrigins,
    mappedOrigins,
    initialLoading,
    isValidating
  } = useWalletByPair()

  return (
    <>
      <HeaderWallet />

      <WalletDetailSections>
        <HeaderWalletBalance
          initialLoading={initialLoading}
          balance={wallet?.balance}
          credit={wallet?.credit_total}
          debit={wallet?.debit_total}
          publisher_id={wallet?.publisher_id}
        />

        {showWalletOrigins && hasMappedOrigins ? (
          <WalletBalanceOrigin showHeading origins={mappedOrigins} />
        ) : null}

        <WalletTableTransaction />
      </WalletDetailSections>

      <LoadingPopUp isActive={isValidating} />
    </>
  )
}

export default AdvertiserTransactions
